import { useCallback, useMemo } from 'react';
import strappedConnected from 'modules/Core/higher-order-components/strappedConnected';
import { compactObject } from 'modules/Core/utils/obj';
import useOnSuccess from 'modules/Core/sub-modules/Dialog/hooks/useOnSuccess';
import useOnError from 'modules/Core/sub-modules/Dialog/hooks/useOnError';
import cells from 'modules/cycles/state';
import { ACTIVITY_KIND } from 'modules/cycles/consts';
import component from './component';

const schema = {
    fields: {
        name: {
            type: "text",
            label: "Name",
            placeholder: "Activity name",
            required: true,
        },
        text: {
            type: "textarea",
            label: "Notes",
            placeholder: "Type notes here",
        },
    }
};

export default strappedConnected(
    component,
    {},
    {
        upsert: (input, id, callback) => cells.upsertActivity.action({ input, id, callback }),
    },
    ({ upsert, close, onSuccess, activityId, cycleId, boothId, gatewayId, initialState, title, kind, onSelectActivity }) => {
        const success = useOnSuccess();
        const error = useOnError();
        const callback = useCallback((res) => {
            if (!res?.id) return error('Saving activity failed')
            success("Successful");
            close()
            onSuccess?.(res);
        }, [onSuccess, close, success, error]);
        const handleSelectActivity = useCallback((selected) => {
            onSelectActivity?.(selected, callback);
        }, [onSelectActivity, callback]);

        return {
            onSubmit: useCallback(({ name, text }) => upsert(compactObject({
                name,
                text,
                cycleId,
                boothId,
                gatewayId,
                kind: kind ?? (activityId ? undefined : ACTIVITY_KIND.STANDARD),
            }), activityId, callback), [upsert, activityId, cycleId, boothId, gatewayId, kind, callback]),
            onSelectActivity: onSelectActivity ? handleSelectActivity : undefined,
            schema,
            boothId,
            initialState: useMemo(() => compactObject(initialState), [initialState]),
            title: title ?? (activityId ? "Edit activity" : "Add to cycle"),
        }
    }
);
